export const dateToString = async (date) => {
  if (date) {
    const string_date = date
      .toISOString()
      .substr(0, 10)
      .split('/')
      .reverse()
      .join('-');

    return string_date;
  }

  return null;
};

export const dateToStringWithTime = async (date) => {
  if (date) {
    const string_date = date
      .toISOString()
      .substr(0, 10)
      .split('/')
      .reverse()
      .join('-');

    return `${string_date} 00:00:00`;
  }

  return null;
};

export const dateToStringDDMMYYY = (date) => {
  // Sem data (null/undefined/''): evita new Date(null) virar epoch (31/12/1969).
  if (!date) return '-';

  const new_date = new Date(date);

  // Data inválida/fora de faixa (ex: dado legado como ano 1607 com offset não-padrão)
  // gera Invalid Date — evita exibir "NaN/NaN/NaN".
  if (Number.isNaN(new_date.getTime())) return '-';

  let day = new_date.getDate();
  let month = new_date.getMonth() + 1;
  const year = new_date.getFullYear();

  day = day < 10 ? `0${day}` : day;
  month = month < 10 ? `0${month}` : month;

  return `${day}/${month}/${year}`;
};

export const dateToStringTime = (date) => {
  const new_date = new Date(date);

  let hour = new_date.getHours();
  let minuts = new_date.getMinutes() + 1;
  let seconds = new_date.getSeconds();

  hour = hour < 10 ? `0${hour}` : hour;
  minuts = minuts < 10 ? `0${minuts}` : minuts;
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${hour}:${minuts}:${seconds}`;
};

export const validateExpectedDelivaryDate = (value) => {
  const today = new Date();

  const expected_delivery_date = new Date(value);

  const diff = Math.abs(today.getTime() - expected_delivery_date.getTime());

  const days_difference = Math.ceil(diff / (1000 * 60 * 60 * 24));

  if (days_difference < 15) return false;

  return true;
};

export const validateIfDelivaryDateIsLatter = (delivery_date) => {
  let status = '';
  const today = new Date();

  const diff = Math.abs(today.getTime() - new Date(delivery_date).getTime());

  const days_difference = Math.ceil(diff / (1000 * 60 * 60 * 24));
  if (days_difference < 7) status = 'atrasado';

  if (new Date(delivery_date) <= today) status = 'expirado';

  return status;
};

export const formatDeltaTime = (deltaTime) => {
  if (deltaTime) {
    const d = deltaTime.split('D')[0].split('P')[1];

    const h = deltaTime.split('H')[0].split('T')[1];

    const m = deltaTime.split('H')[1].split('M')[0];

    const s = deltaTime.split('M')[1].split('.')[0];

    // Texto humanizado (05/07): só as unidades relevantes — "1 dia 2h 36min",
    // "36min 18s", "9s"... Com 1 dia ou mais, os segundos são ruído e saem.
    const days = Number(d) || 0;
    const hours = Number(h) || 0;
    const minutes = Number(m) || 0;
    const seconds = Number(s) || 0;

    const parts = [];
    if (days > 0) parts.push(`${days} ${days > 1 ? 'dias' : 'dia'}`);
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}min`);
    if (seconds > 0 && days === 0) parts.push(`${seconds}s`);

    return {
      days: d,
      days_text: `${d} ${d > 1 ? ' dias' : ' dia'}`,
      hours: h,
      minutes: m,
      seconds: s,
      human: parts.length > 0 ? parts.join(' ') : 'menos de 1s',
      // Total em segundos — para comparar durações (ex.: destacar no relatório
      // de ações a etapa em que o pedido ficou mais tempo parado).
      total_seconds: days * 86400 + hours * 3600 + minutes * 60 + seconds,
    };
  }

  return 0;
};
